/**
 * The applicant source for this request, or null when none should be forwarded.
 *
 * Resolved once during SSR by plugins/tracking-bag.server.ts. Only the value
 * crosses into the payload, never the settings it came from, nor the rung it
 * came from — useJobShopSettings cannot read its cache on the client, so the
 * ladder runs server-side and the provenance stays there with it.
 */
export function useResolvedSource() {
  return useState<string | null>("resolvedSource", () => null)
}
